import { handleActions } from "redux-actions";
import { getInitialRangeOptions } from "../../constants";
import {
  SET_LOADING,
  SET_CONSTANTS,
  FETCH_MODULE,
  TOGGLE_VIEW,
  FETCH_FILTERS,
  UPDATE_FILTERS,
  TOTAL_REVENUE,
  SET_ALL_SITES_MODE,
  UPDATE_REFERRAL_CATEGORIES,
  SET_FILTERS_LOADING
} from "../sagas/referrals";
import { getSelectedRangeOptionWithCustom } from "../../../../../utils/date-range-options";

export const initialState = {
  dataTable: {},
  initialRequest: false,
  options: {},
  listeners: [],
  isFiltersLoading: false,
  isLoading: true,
  material: false,
  isTable: false,
  isAllSitesMode: false,
  disabledUpdateButton: false,
  filters: {
    categories: "",
    filtersDirty: false,
    compareDates: false,
    referralCategory: false,
    willUpdateFilters: false
  }
};

const getActionKey = (key) => key + "/" + TOTAL_REVENUE;

export default handleActions(
  {
    [getActionKey(SET_LOADING)]: (state, { payload }) => ({
      ...state,
      isLoading: payload
    }),
    [getActionKey(SET_ALL_SITES_MODE)]: (state, { payload }) => ({
      ...state,
      isAllSitesMode: { ...state, payload }
    }),
    [getActionKey(SET_FILTERS_LOADING)]: (state, { payload }) => ({
      ...state,
      isFiltersLoading: payload,
      disabledUpdateButton: payload
    }),
    [getActionKey(UPDATE_REFERRAL_CATEGORIES)]: (state, { payload: { ...rest } }) => {
      const categories = rest.classTypes.options.ref_categories;
      return {
        ...state,
        filters: {
          ...state.filters,
          referralValues: categories,
          referralCategories: categories,
          referralCategory:
            state.filters?.referralCategory === undefined
              ? initialState.filters.referralCategory
              : state.filters.referralCategory,
          ...rest
        }
      };
    },
    [getActionKey(SET_CONSTANTS)]: (state, { payload }) => ({
      ...state,
      ...payload,
      initialRequest: true
    }),
    [getActionKey(TOGGLE_VIEW)]: (state, { payload }) => {
      return { ...state, isTable: payload };
    },
    [getActionKey(UPDATE_FILTERS)]: (state, { payload }) => {
      return {
        ...state,
        filters: { ...state.filters, filtersDirty: true, ...payload }
      };
    },
    [getActionKey(FETCH_MODULE)]: (state, { payload: { data_table: dataTable, ...rest } }) => {
      return {
        ...state,
        ...rest,
        filters: { ...state.filters, filtersDirty: false },
        isLoading: false,
        dataTable
      };
    },
    [getActionKey(FETCH_FILTERS)]: (
      state,
      { payload: { start_date: startDate, end_date: endDate, ...rest } }
    ) => {
      const categories = rest.classTypes.options.ref_categories;
      // fetch filters always reinitializes all filters with default values

      return {
        ...state,
        isTable: false,
        filters: {
          ...initialState.filters,
          ...rest,
          referralValues: categories,
          referralCategories: categories,
          referralCategory:
            state.filters?.referralCategory === undefined
              ? initialState.filters.referralCategory
              : state.filters.referralCategory,
          startDate,
          endDate,
          rangeValue: getSelectedRangeOptionWithCustom({ payload: { startDate, endDate } }), // set as current selected
          // get preexisting range options from getRangeOptions function + Custom Range
          rangeOptions: getInitialRangeOptions(startDate, endDate, state.theBeginningOfTime).filter(
            (option) => !option.name.includes("Last 30 Days")
          )
        }
      };
    }
  },
  initialState
);
